import { BehaviorContext } from '../../behavior-context';
import { Behavior } from '../../behavior';
import { Injectable } from '@angular/core';

@Injectable()
export class InputSetLabel implements Behavior {
  async execute(
    args: { [key: string]: any },
    context: BehaviorContext
  ): Promise<any> {
    context.target.model.label = args.label;
  }
}
